"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EngagementRecord = _interopRequireDefault(require("customer-data-objects/engagement/EngagementRecord"));

var _react = require("react");

var EngagementType = _react.PropTypes.instanceOf(_EngagementRecord.default);

var _default = EngagementType;
exports.default = _default;
module.exports = exports.default;